namespace $.$$ {
	export class $mol_audio_demo_sequencer extends $.$mol_audio_demo_sequencer {
	}
}
